import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map } from 'rxjs/operators';
import { TenantService } from './tenant.service';

/**
 * Activa a rota do dealer quando o profile tem um template diferente de 'motorbest'.
 * init() é idempotente — na segunda chamada devolve o profile já resolvido.
 */
export const matchDealerTemplate: CanMatchFn = () =>
  inject(TenantService)
    .init()
    .pipe(
      map((profile) => {
        const t = profile?.dealerSite?.template;
        return !!t && t !== 'motorbest';
      }),
    );
